import { createSlice } from "@reduxjs/toolkit";
import menus from "../../pages/Settings/UserManagement/ModuleAccess/json/menu";
let initialState = menus;

const findDataSlice = createSlice({
  name: "findData",
  initialState: initialState,
  reducers: {
    setfindData: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});
export const { setfindData } = findDataSlice.actions;
export default findDataSlice.reducer;